import type { InclusionField } from './types';

export const INCLUSION_FIELDS: Array<InclusionField> = [];
